import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { Component } from 'vue';
import { IntegrationFacebookConversionData as IntegrationEspFacebookConversionData } from './Data';

export enum IntegrationEspFacebookConversionType {
  ID,
  CODE
}

export interface IntegrationEspFacebookConversionState extends BaseIntegrationState {
  pixelId?: string;
  type?: IntegrationEspFacebookConversionType;
}

export class IntegrationEspFacebookConversionModel extends BaseIntegration<
  IntegrationEspFacebookConversionData,
  IntegrationEspFacebookConversionState
> {
  parse(data: IntegrationEspFacebookConversionData) {
    super.parse(data);

    this.state.pixelId = data.settings?.pixel_id;

    let type: IntegrationEspFacebookConversionType | undefined;

    if (data.settings?.type) {
      switch (data.settings.type) {
        case 'id':
          type = IntegrationEspFacebookConversionType.ID;
          break;
        case 'code':
          type = IntegrationEspFacebookConversionType.CODE;
          break;
      }
    }

    this.state.type = type;
  }

  getVueComponent(): Promise<Component> {
    return import('@/components/integrations/esp/facebook-conversion/View.vue');
  }

  hasVueComponent() {
    return true;
  }

  authorSignature(): string {
    return 'Istvan Bovan';
  }
}
